import { t } from 'i18next';
import { useJsonAPI } from 'json-api-hooks';
import React, { FC } from 'react';
import { useNavigate } from 'react-router';

import CollectionTable from '../../components/./Collection/CollectionTable';
import RelativeDate from '../../components/RelativeDate';
import { Column } from '../../components/Table';
import PriorityDetail from '../../details/PriorityDetail';
import { useCurrentActor } from '../../hooks/useCurrentActor';
import useModalDispatch from '../../hooks/useModalDispatch';
import { formatNumber } from '../../lib/formatters';
import retrievePath from '../../lib/iris';
import SignInModal from '../../modals/SignInModal';
import { StreetResource } from '../../models';

const columns: Column<'streets'>[] = [
  {
    label: t('table.streets.columns.name'),
    attribute: 'name',
    sortable: true,
  },
  {
    label: t('table.streets.columns.priority'),
    attribute: 'priority',
    render: ({ attributes: { priority } }) => <PriorityDetail height="0.75em" priority={priority} />,
    sortable: true,
  },
  {
    label: t('table.streets.columns.lastVisitedAt'),
    attribute: 'lastVisitedAt',
    render: ({ attributes: { lastVisitedAt } }) => <RelativeDate date={lastVisitedAt} />,
    sortable: true
  },
  {
    label: t('table.streets.columns.pendingAddressesCount'),
    attribute: 'pendingAddressesCount',
    render: ({ attributes: { pendingAddressesCount } }) => formatNumber(pendingAddressesCount),
    sortable: true,
  },
];

const StreetTable: FC = () => {
  const navigate = useNavigate();
  const { router } = useJsonAPI();
  const dispatchSignInModal = useModalDispatch(SignInModal);
  const { actorType } = useCurrentActor();

  const onRowClick = (street: StreetResource) => {
    if (actorType === 'GuestUser') {
      dispatchSignInModal({ redirectUrl: router.resourceRoute(street) });
    } else {
      navigate(retrievePath(router.resourceRoute(street)));
    }
  };

  return <CollectionTable columns={columns} onRowClick={onRowClick} />;
};

export default StreetTable;
